import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { trackDevelopmentView, trackEvent } from "../../../shared/helpers/analytics";
import EmailForm from "../../../shared/forms/EmailForm";
import "../styles/AvwakinDevelopmentPage.css";

function AvwakinDevelopmentPage() {
  const [showForm, setShowForm] = useState(false);
  const location = useLocation();

  useEffect(() => { trackDevelopmentView(location.key); }, [location.key]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleToggleForm = () => {
    if (!showForm) trackEvent("development_contact_open");
    setShowForm((prev) => !prev);
  };

  return (
    <div className="avwakin-container">

      {/* ================= HERO ================= */}
      <section className="avwakin-section white">
        <div className="avwakin-section-inner">
          <h1>Avwakin Development</h1>
          <p>
            No templates. No limits. Just systems built around you.
          </p>
        </div>
      </section>


      {/* ================= SERVICES ================= */}
      <section id="services" className="avwakin-section grey">
        <div className="avwakin-section-inner">
          <h2>Services</h2>

          <p><strong>Lean, custom-built websites designed for speed, clarity, and control.</strong></p>
          <p>No bloated themes. No plugin dependency. Just fast, purpose-built sites that do exactly what they’re meant to do.</p>

          <br />

          <p><strong>Custom web systems built around your workflow.</strong></p>
          <p>From user dashboards to internal tools, we design and develop scalable applications that give you ownership and flexibility.</p>

          <br />

          <p><strong>Sell without platform ceilings.</strong></p>
          <p>Integrated checkout, digital delivery, automated fulfillment, and infrastructure built to grow with your business.</p>

          <br />

          <p><strong>Reduce friction. Increase leverage.</strong></p>
          <p>Custom automation for operations, marketing, reporting, and internal processes — built to save time and eliminate repetition.</p>
        </div>
      </section>


      {/* ================= PROCESS ================= */}
      <section id="process" className="avwakin-section white">
        <div className="avwakin-section-inner">
          <h2>How It Works</h2>

          <p><strong>01 — Define</strong></p>
          <p><strong>Clarity before code.</strong></p>
          <p>We map your goals, constraints, and growth plans before a single line is written. The structure comes first.</p>

          <br />

          <p><strong>02 — Build</strong></p>
          <p><strong>Purpose-built from the ground up.</strong></p>
          <p>No templates. No patchwork. Every component is designed around your workflow, performance needs, and long-term flexibility.</p>

          <br />

          <p><strong>03 — Launch</strong></p>
          <p><strong>Delivered clean. Built to last.</strong></p>
          <p>Deployment, documentation, and a system you understand and control — not something you’re dependent on.</p>
        </div>
      </section>


      {/* ================= WHAT I BUILD ================= */}
      <section id="build" className="avwakin-section grey">
        <div className="avwakin-section-inner">
          <h2>What I Build</h2>

          <p><strong>Custom Web Platforms</strong></p>
          <p>Full frontend and backend systems built from the ground up — not layered onto a template.</p>

          <br />

          <p><strong>Admin Dashboards & Internal Tools</strong></p>
          <p>Custom control panels for managing content, products, analytics, automation, and operations.</p>

          <br />

          <p><strong>E-Commerce Infrastructure</strong></p>
          <p>Stripe integration, product management, fulfillment automation, discount logic, and order workflows.</p>

          <br />

          <p><strong>Automation Systems</strong></p>
          <p>Scheduled posting engines, ranking trackers, cron-based jobs, reporting tools, and workflow automation.</p>

          <br />

          <p><strong>API & Integration Architecture</strong></p>
          <p>Secure integrations with payment processors, social platforms, fulfillment providers, and third-party services.</p>

          <br />

          <p><strong>Database Design & Backend Logic</strong></p>
          <p>Structured MySQL systems, scalable data models, and backend logic designed for growth.</p>
        </div>
      </section>


      {/* ================= CONTACT ================= */}
      <section id="contact" className="avwakin-section white">
        <div className="avwakin-section-inner">
          <h2>Have an idea? Let’s talk it through.</h2>

          <p>
            Share what you’re building, and I’ll map out the 
            system behind it.
          </p>

          <br />

          <button
            className="avwakin-contact-btn"
            onClick={handleToggleForm}
          >
            {showForm ? "Close Form" : "Start the Conversation"}
          </button>

          {showForm && (
            <div className="avwakin-form-wrapper">
              <EmailForm source="avwakin" />
            </div>
          )}
        </div>
      </section>

    </div>
  );
}

export default AvwakinDevelopmentPage;
